import React, {useMemo, useState} from "react";
import TickerChip from "../../../components/TickerChip";
import {stringMixin} from "../../../utils/strings";
import {Card, Col, Divider, Drawer, Grid, Row, Space, Switch, Table, Typography} from "antd";
import {proRataFillPortfolio} from "../../../lib/weightSchemes";
import LoadingAnimation from "../../../components/LoadingAnimation";
import Button from "@mui/material/Button";
import SmaTickersTable from "../SmaTickersTable";
import TickerWeightChart from "./TickerWeightChart";
const {useBreakpoint} = Grid;

const SmaProcessingSteps = [

                    'Fetching ETF Holdings',
                    'Pro Rata Factoring Stock Weights',
                    'Consolidating Stocks Into Single List',
                    'Reducing Colinear Pairs and High Density Clusters',
                    'Bringing Stocks in Line with Market Cap',
                    'Adding in Stocks Needed to Align Sector Risks'
]

const SmaPreview = ({tickerData, etfColors, sectorColors, tickersDropped, setView, etfData,
                        isMain=true})=>{

    const [isProcessing, setIsProcessing] = useState(isMain);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [hideSider, setHideSider] = useState(false);
    const bp = useBreakpoint();

    const totalTickers = tickerData.length + tickersDropped.length;
    const sortedData = useMemo(()=>{
        return [...Object.values(etfData)].sort((a, b)=>b.weight-a.weight);
    }, [etfData]);

    const columns = [
        {
            title: `ETFs (${sortedData.length} Total)`,
            key: 'symbol',
            render: (_, record)=><TickerChip ticker={{...record, symbol: `${record.symbol} - ${stringMixin.pct(record.weight)}`}}/>
        },
        {
            title: "Weight",
            key: 'weight',
            dataIndex: 'weight',
            render: (v)=>stringMixin.pct(v)
        }
    ];

    const SideStack = ()=>{
        return (
            <>
                <Row justify={'end'} className={'p-3'}>
                        <Switch checked={!hideSider} onClick={()=>setHideSider(true)} />
                </Row>
                <Table columns={columns} dataSource={sortedData} pagination={{pageSize: 5}}/>
                <TickerWeightChart stocks={proRataFillPortfolio([...tickerData, ...tickersDropped])} />
            </>
        )
    }

    return (
        <div>
            {isProcessing && (
                <LoadingAnimation words={SmaProcessingSteps}
                                  title={'Generating New SMA Portfolio'}
                                  seconds={5}
                                  maxInteger={tickerData.length + tickersDropped.length}
                                  onFinish={()=>setIsProcessing(false)}
                />
            )}
            {!isProcessing && (
                <Row wrap={!bp.xxl}>
                    <Col flex={'1'}>
                        <div style={{textAlign: 'center'}} className={'p-6'}>
                            <Typography.Title style={{fontSize: '3.75rem', textShadow: '2px 2px 3px rgba(0, 0, 0, 0.2)'}}><span style={{color: "var(--blue)", fontWeight: '600'}}>
                                {totalTickers}</span> Total Stocks</Typography.Title>
                            {/*<BubbleText text={`${tickerData.length} STOCKS KEPT`} />*/}
                        </div>
                        <Row className={'pb-6'} justify={'center'} style={{ borderBottom: '2px solid #ededed'}}>
                            <Space>
                                {bp.xxl && isMain && (
                                    <Button className={'pill'} onClick={()=>setHideSider(!hideSider)}>{hideSider ? 'Show Details' : "Hide Details"}</Button>
                                )}
                                {!bp.xxl || !isMain && (
                                    <Button className={'pill'} onClick={()=>setDrawerOpen(true)}>Show Details</Button>
                                )}
                                <Button className={'pill'} variant={'contained'} color={'info'} onClick={()=>setView('table')}>
                                    Edit Now
                                </Button>

                            </Space>
                        </Row>
                        <Divider/>
                        <div className={'px-6'}>
                            {tickerData && <SmaTickersTable data={tickerData}
                                                        etfColors={etfColors}
                                                        sectorColors={sectorColors}
                                                        logoCloudCount={15}
                                                        hideExport={true}
                                                            bordered={false}
                            />}
                        </div>
                    </Col>
                    {!hideSider && isMain && (
                        <Col flex={'0 0 300px'} style={{borderLeft: '2px solid #ededed'}}>
                            <SideStack />
                        </Col>
                    )}
                </Row>
            )}
            <Drawer open={drawerOpen} onClose={()=>setDrawerOpen(false)}>
                <Card bordered={false}>
                    <SideStack />
                </Card>
            </Drawer>
        </div>
    )
}

export default SmaPreview;